// @ts-nocheck
import styled from 'styled-components';

export const ShortcutsStyle = styled.section`
  display: flex;
  box-shadow: inset 0 2px 36px -4px rgba(18,22,30,0.16);
  flex-direction: column;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.9);

  .reportingShortcuts{
    &__container {
      display: flex;
      height: 56px;
    }
    &__links{
      display: flex;
      gap:24px;
      justify-content: flex-start;
    }
    &__link {
      font-family: ${props => props.theme.fontSemiBold};
      color: #FF8B43;
      font-size: 14px;
      line-height: 16px;
    }
    &__sectionViewButtonContainer {
      display: flex;
      margin-left: auto;
      gap: 8px;
      align-items: center;
      &__label {
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeS};
        white-space: nowrap;
      }
      &__button {
        cursor: pointer;
        padding: 8px;
        font-size: ${props => props.theme.fontSizeS};
        color: ${props => props.theme.uiColors.reportingIconColor};
      }
    }
  }
`;
